// Parses the Bulk / CSV box: one candidate per line, "email" or "email, role".
// Role names match the catalog ignoring case, spaces and hyphens, so
// "Front-end Developer" is Frontend Developer. A typed role that is not in
// the list is an error — it must not silently take the default role.

import { findCatalogRole } from "./partnerRoleCatalog";

export { findCatalogRole, roleKey } from "./partnerRoleCatalog";

const EMAIL_RE = /^[^\s@,;]+@[^\s@,;]+\.[A-Za-z]{2,}$/;

export function parseBulkCandidates(text, roles = [], defaultRole = null) {
  const items = [];
  const issues = [];
  String(text || "")
    .split(/\r?\n/)
    .forEach((raw, index) => {
      const line = raw.trim();
      if (!line) return;
      const n = index + 1;
      const parts = line
        .split(",")
        .map((part) => part.trim())
        .filter(Boolean);
      const email = parts.find((part) => part.includes("@"));
      if (!email || !EMAIL_RE.test(email)) {
        issues.push({ line: n, reason: "Missing or invalid email" });
        return;
      }
      const rest = parts.filter((part) => part !== email);
      if (!rest.length) {
        if (!defaultRole?.t) {
          issues.push({ line: n, reason: "No role — pick a default role" });
          return;
        }
        items.push({ email, role: defaultRole.t, cr: defaultRole.c || 0, line: n });
        return;
      }
      const typed = rest.join(" ");
      const hit =
        findCatalogRole(typed, roles) ||
        rest.map((part) => findCatalogRole(part, roles)).find(Boolean);
      if (!hit) {
        issues.push({ line: n, reason: `"${typed}" is not a known role` });
        return;
      }
      items.push({ email, role: hit.t, cr: hit.c || 0, line: n });
    });
  return { items, issues };
}
